import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ProjectsService } from '../projects/projects.service';
import { Project } from '../models/models.lib';

export const projectsResolver: ResolveFn<Project[]> = (route, state) => {
  return inject(ProjectsService).get();
};
